import { NavigationBarPosition, Scale, Theme } from "@/appTypes/uiPreferences.ts"

type Secrets = {
  token?: string
  userId?: number
  username?: string
  roleId?: string
  unit?: string
  units?: string[]
  doctorCode?: string
  theme?: Theme
  scale?: Scale
  navigationBarPosition?: NavigationBarPosition
  fullScreen?: boolean
}

function setSecret<K extends keyof Secrets>(secret: K, value: Secrets[K]) {
  if (typeof value !== "undefined") {
    // eslint-disable-next-line no-restricted-syntax
    localStorage.setItem(secret, JSON.stringify(value))
  } else {
    console.error("secret cannot be undefined. to remove secret use LocalStorage.removeSecret")
  }
}

function getSecret<K extends keyof Secrets>(secret: K): Secrets[K] | null {
  // eslint-disable-next-line no-restricted-syntax
  const storedValue = localStorage.getItem(secret)
  return storedValue ? (JSON.parse(storedValue) as Secrets[K]) : null
}

function getSecrets<K extends keyof Secrets>(
  ...secrets: K[]
): { [P in K]: Secrets[P] | null } {
  const result = {} as { [P in K]: Secrets[P] | null }

  for (const key of secrets) {
    // eslint-disable-next-line no-restricted-syntax
    const storedValue = localStorage.getItem(key)
    result[key] = storedValue ? (JSON.parse(storedValue) as Secrets[K]) : null
  }

  return result
}

function removeSecret(key: keyof Secrets): void {
  // eslint-disable-next-line no-restricted-syntax
  localStorage.removeItem(key)
}

function clear(): void {
  // eslint-disable-next-line no-restricted-syntax
  localStorage.clear()
}

function setDefaults() {
  const secrets: Secrets = {
    theme: "dark",
    scale: "medium",
  }
  //set value if it doesn't already exist
  Object.entries(secrets).forEach(([key, value]) => {
    const k = key as keyof Secrets
    if (!LocalStorage.getSecret(k)) {
      LocalStorage.setSecret(k, value)
    }
  })
}

export const LocalStorage = {
  setSecret,
  getSecret,
  getSecrets,
  removeSecret,
  clear,
  setDefaults,
}
